import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

export default class SafetyAppaltiService {
    static getTipi = () => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/appalti/tipi`;
            ApiService.postRequest(resolve, reject, url, {});
        });
    };

    static byAzienda = (id_azienda) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/appalti/byAzienda`;
            ApiService.postRequest(resolve, reject, url, { id_azienda });
        });
    };

    static create = (formData) => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/appalti/create`;
        return ApiService.postFormData(url, formData);
    };

    static deleteAppalto = (id_appalto) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/appalti/delete`;
            ApiService.postRequest(resolve, reject, url, { id_appalto });
        });
    };

    static download = (id_appalto, filename) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/appalti/download`;
            ApiService.postRequestWithDownload(resolve, reject, url, { id_appalto, filename });
        });
    };

    // --- Personale impiegato nell'appalto ---
    static personaleByAppalto = (id_appalto) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/appalti/personale/byAppalto`;
            ApiService.postRequest(resolve, reject, url, { id_appalto });
        });
    };

    static personaleSave = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/appalti/personale/save`;
            ApiService.postRequest(resolve, reject, url, data);
        });
    };

    static personaleDelete = (id_personale) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/appalti/personale/delete`;
            ApiService.postRequest(resolve, reject, url, { id_personale });
        });
    };

    // --- Dotazione assegnata all'appalto ---
    static dotazioniByAppalto = (id_appalto) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/appalti/dotazioni/byAppalto`;
            ApiService.postRequest(resolve, reject, url, { id_appalto });
        });
    };

    static dotazioniSave = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/appalti/dotazioni/save`;
            ApiService.postRequest(resolve, reject, url, data);
        });
    };

    static dotazioniDelete = (id_dotazione) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/appalti/dotazioni/delete`;
            ApiService.postRequest(resolve, reject, url, { id_dotazione });
        });
    };
}
